import React from "react";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { getDocument } from "pdfjs-dist"; // Use pdfjs-dist to access the document directly
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Document } from "react-pdf";



const PdfViewer = ({ pdfFile, onPdfLoad }) => {
  // Function to capture the first page's dimensions
  const handleDocumentLoad = (pdf) => {
    // Access the first page of the document
    onPdfLoad();
  };

  return (
    <div style={{ userSelect: "none" }}>
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
      >
        <Viewer
          fileUrl={pdfFile}
          defaultScale={SpecialZoomLevel.PageWidth} // Optional: Zoom PDF to full page width
          onDocumentLoad={handleDocumentLoad} // Capture the document load event
          enableSmoothScroll={true}
        />
      </Worker>
    </div>
  );
};

export default PdfViewer;
